import { render } from "./index.vue?vue&type=template&id=000d2a37&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=000d2a37&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=000d2a37&lang=less"
script.render = render
script.__scopeId = "data-v-000d2a37"

export default script